import { api } from 'api/api';
import { useContext, useEffect, useState } from 'react';
const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const useViewClube = () => {
  const [clubeVantagens, setClubeVantagens] = useState([]);
  const fetchClubeVantagens = async () => {
    try {
      const response = await api(ENDPOINT + `/clients/getClubeVantagens`, {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      });
      const postsData = await response.json();
      console.log(postsData);
      setClubeVantagens(postsData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchClubeVantagens();
  }, []);

  const itensUltimo = clubeVantagens?.filter((option) => option.ultimo);
  const itensNaoUltimo = clubeVantagens?.filter((option) => !option.ultimo);
  const itensOrdenados = [...itensNaoUltimo, ...itensUltimo];

  return { itensOrdenados };
};

export default useViewClube;
